import { Box } from '@mui/material';
import { Dvr } from '@mui/icons-material';
import eventBus from '../../../eventBus';
import NativeShare from './NativeShare';
import LinkedInLogo from './linked_In_logo.svg';

export default function ShareItems({ setNextStepType }) {
  const iconStyle = {
    margin: '8px 24px',
    width: '40px',
    height: '40px',
    cursor: 'pointer',
  };

  return (
    <>
      <Box sx={{ position: 'relative', zIndex: 10 }}>
        <img
          src={LinkedInLogo}
          alt="LinkedIn Logo"
          style={iconStyle}
          onClick={() => {
            if (setNextStepType) {
              setNextStepType('linkedin');
              return;
            }
            eventBus.dispatch('openLinkedInPostModal');
          }}
        />
        <img
          src="/icons/facebook_logo.svg"
          alt="Facebook Logo"
          style={iconStyle}
          onClick={() => {
            if (setNextStepType) {
              setNextStepType('facebook');
              return;
            }
            eventBus.dispatch('openCopyModal', {
              modalType: 'facebook',
            });
          }}
        />
        <img
          src="/icons/x_logo.svg"
          alt="X Logo"
          style={iconStyle}
          onClick={() => {
            if (setNextStepType) {
              setNextStepType('x');
              return;
            }
            eventBus.dispatch('openCopyModal', {
              modalType: 'x',
            });
          }}
        />
      </Box>
      <Box sx={{ position: 'relative', zIndex: 10 }}>
        <NativeShare iconStyle={iconStyle} />
        <Dvr
          sx={{
            color: '#0866FF',
            margin: '8px 24px',
            fontSize: '2.5rem',
            cursor: 'pointer',
          }}
          onClick={() => {
            if (setNextStepType) {
              setNextStepType('code');
              return;
            }
            eventBus.dispatch('openCopyModal');
          }}
        />
        <img
          src="/icons/email_icon.svg"
          alt="Email Logo"
          style={iconStyle}
          onClick={() => {
            if (setNextStepType) {
              setNextStepType('email');
              return;
            }
            eventBus.dispatch('openEmailModal');
          }}
        />
      </Box>
    </>
  );
}
